import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { CalculationService, DataService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';

import { debounce, find, findIndex } from 'lodash';
import { Subscription } from 'rxjs';
import { subItemTypeIcons } from 'app/constants/itemType.constants';

@Component({
  selector: 'app-internal-services',
  templateUrl: './internal-services.component.html',
  styleUrls: ['./internal-services.component.scss'],
})
export class InternalServicesComponent implements OnInit, OnDestroy {
  @Input() orderStatus: string = '';
  @Input() selectedInternalServices: any = {};
  @Input() selectedServiceInspection: any = {};
  @Input() customFleetSettings: any = {};
  @Input() query: any = {};
  @Input() serviceTags: any = [];
  @Input() currentLang: string = 'en';
  @Input() isPartslookupService: boolean = false;

  subItemTypeIcons: any = subItemTypeIcons;
  limit: number = 250;
  skip: number = 0;
  currentPage: number = 1;
  internalServices: any[] = [];
  usd: string = currency.USD;
  dataListener: Subscription;
  pageIndex: number = 0;
  _internalServices: any[] = [];
  _cannerdServices: any[] = [];
  totalPages: number = 0;
  isLoading: boolean = false;
  checkboxIcon: string = 'fal fa-check';
  selectedItems: any = {};
  isSubletTrackingEnabled: boolean = false;
  constructor(private calculationService: CalculationService, private helperService: HelperService, private httpService: HTTPService, private dataService: DataService) { }

  ngOnInit() {
    this.getCannedServicesList({
      offset: this.pageIndex,
      limit: this.limit,
      skip: this.pageIndex * this.limit,
      sortField: 'title',
      sortOrder: 1,
      search: this.query,
      activeStatus: true,
      populateInspection: true,
    });
    this.setDataService();
  }

  ngOnDestroy() {
    if (this.dataListener) {
      this.dataListener.unsubscribe();
    }
  }

  getCannedServicesList(conf: any, scrollEvent = false) {
    let cannedServices = [];
    this.isLoading = true;
    this.httpService
      .getServices(conf)
      .then(
        (services) => {
          // changes made on need on ALP-13204
          if (services && services.records && services.records.length > 0) {
            this.totalPages = Math.ceil(services.totalCount / this.limit);
            cannedServices = services.records.filter((service: any) => {
              const items = [];
              let isFoundPartLookup = false;
              service.items.forEach((item: any, index: number) => {
                if (item.subItems) {
                  item.subItems.forEach((subItem: any) => {
                    subItem.total = this.calculationService.roundOff(subItem.price * subItem.count);
                    subItem.quantity = this.helperService.renderItemQuantity(subItem);
                    if (subItem.type === 'partLookUp') {
                      isFoundPartLookup = true;
                    }
                  });
                }
                if (item.type === 'sublet' && !item.tags) {
                  item.tags = [];
                  this.setSubletTags(item);
                }
                if (item.status) {
                  if (this.customFleetSettings) {
                    const { isLaborRateOverride, isPricingMatrixOverride, customLaborRate, customPartPricingMatrix } = this.customFleetSettings;

                    if (item.type === 'labor' && isLaborRateOverride && customLaborRate) {
                      item.billRate = customLaborRate && customLaborRate.rate;
                      item.price = customLaborRate && customLaborRate.rate;
                      item.pricing = { pricingId: customLaborRate.pricingId, name: customLaborRate.name };
                    }

                    if (['part', 'tire'].includes(item.type) && isPricingMatrixOverride && customPartPricingMatrix) {
                      item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, customPartPricingMatrix);
                      item.pricing = { pricingId: customPartPricingMatrix.pricingId, name: customPartPricingMatrix.name };
                    }
                  }

                  item.isChecked = false;
                  item.sitemId = index;
                  item.quantity = this.helperService.renderItemQuantity(item);
                  item.total = this.calculationService.roundOff(item.price * item.count);
                  items.push(item);
                }
                if (item.type === 'partLookUp') {
                  isFoundPartLookup = true;
                }
              });

              service.items = items;

              service.hasPartsLookup = isFoundPartLookup;
              service.serviceTotal.part = 0;
              service.serviceTotal.labor = 0;
              service.serviceTotal.tire = 0;
              service.serviceTotal.hazmatFee = 0;
              service.serviceTotal.other = 0;
              service.serviceTotal.sublet = 0;

              service.items.forEach((item: any) => {
                if (item.type === 'bundle') {
                  if (item.subItems && item.subItems.length) {
                    item.subItems.forEach((subItem: any) => {
                      service.serviceTotal[subItem.type] += Number(subItem.flatRateAmount);
                    });
                  }
                } else {
                  service.serviceTotal[item.type] += item.total;
                }
              });

              service.serviceTotal.total =
                service.serviceTotal.part + service.serviceTotal.labor + service.serviceTotal.tire + service.serviceTotal.hazmatFee + service.serviceTotal.other + (service.serviceTotal?.sublet || 0);
              service.extra = this.setServiceTotals(service);

              if (service.inspection && service.inspection._id) {
                service.inspection.inspectionId = service.inspection._id;
                service.inspectionCount = this.setInspectionCounts(service.inspection);
              }

              return service.items && service.items.length;
            });

            // changes made on need on ALP-13204
            // this._cannerdServices = this._cannerdServices.concat(cannedServices);
            if (this.isPartslookupService) {
              cannedServices = cannedServices.filter((service) => service.hasPartsLookup);
            } else if (!this.dataService.isQuickServiceEnabled) {
              cannedServices = cannedServices.filter((service) => !service.hasPartsLookup);
            }
            this._cannerdServices = cannedServices;

            if (!conf.offset) {
              this.internalServices = this.helperService.deepCopy(this._cannerdServices);
            } else {
              this.internalServices = [...this._cannerdServices, ...this.helperService.deepCopy(this._cannerdServices)];
            }

            this._internalServices = this.helperService.deepCopy(this.internalServices);
          } else {
            // changes made on need on ALP-13204
            this.internalServices = [];
            this._internalServices = [];
          }
        },
        (error) => {
          this.helperService.showToaster('error', error);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  setDataService() {
    this.dataListener = this.dataService.getData().subscribe(({ data }) => {
      if (data.key === 'motor-on-search') {
        // this.internalServices = this._internalServices.filter(({ title }) => new RegExp(data.data.query, 'i').test(title));
        this.pageIndex = 0;
        this.totalPages = 0;
        this.getCannedServicesList({
          offset: this.pageIndex,
          limit: this.limit,
          skip: this.pageIndex * this.limit,
          sortField: 'title',
          sortOrder: 1,
          search: data.data.query || '',
          activeStatus: true,
          populateInspection: true,
        });
      }
    });
    this.isSubletTrackingEnabled = this.dataService.isSubletTrackingEnabled;
  }

  setServiceTotals(service: any) {
    const data = {
      hours: 0,
      parts: 0,
      tires: 0,
      fees: 0,
      other: 0,
      sublet: 0,
      partCost: 0,
      laborCost: 0,
      tireCost: 0,
      feeCost: 0,
      otherCost: 0,
      subletCost: 0,
      isAdded: false,
    };

    if (service.items && service.items.length) {
      service.items.forEach((item: any) => {
        if (item.type === 'labor') {
          data.hours += 1 * item.count;
          data.laborCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'part') {
          data.parts += 1 * item.count;
          data.partCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'tire') {
          data.tires += 1 * item.count;
          data.tireCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'hazmatFee') {
          data.fees += 1 * item.count;
          data.feeCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'other') {
          data.other += 1 * item.count;
          data.otherCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'sublet') {
          data.sublet += 1 * item.count;
          data.subletCost += this.calculationService.roundOff(item.subTotal);
        }

        if (item.type === 'bundle' && item.subItems && item.subItems.length) {
          item.subItems.forEach((subItem: any) => {
            if (subItem.type === 'labor') {
              data.hours += 1 * subItem.count;
              data.laborCost += this.calculationService.roundOff(subItem.subTotal);
            }

            if (subItem.type === 'part') {
              data.parts += 1 * subItem.count;
              data.partCost += this.calculationService.roundOff(subItem.subTotal);
            }

            if (subItem.type === 'tire') {
              data.tires += 1 * subItem.count;
              data.tireCost += this.calculationService.roundOff(subItem.subTotal);
            }

            if (subItem.type === 'hazmatFee') {
              data.fees += 1 * subItem.count;
              data.feeCost += this.calculationService.roundOff(subItem.subTotal);
            }

            if (subItem.type === 'other') {
              data.other += 1 * subItem.count;
              data.otherCost += this.calculationService.roundOff(subItem.subTotal);
            }

            if (subItem.type === 'sublet') {
              data.sublet += 1 * subItem.count;
              data.subletCost += this.calculationService.roundOff(subItem.subTotal);
            }
          });
        }
      });
    }

    return data;
  }

  setInspectionCounts(inspection: any = {}) {
    let categoryCount = 0;
    let itemCount = 0;
    let isItemExists = false;

    if (inspection && inspection.category && inspection.category.length) {
      inspection.category.forEach((category: any) => {
        if (category.inspectionItems.length) {
          category.inspectionItems.forEach(({ isChecked }: any) => {
            if (isChecked) {
              itemCount += 1;
              isItemExists = true;
            }
          });
        }

        if (isItemExists) {
          categoryCount += 1;
          isItemExists = false;
        }
      });
    }

    return {
      categoryCount,
      itemCount,
    };
  }

  /** Add the service and all the items to inspection */
  addToEstmate(service: any, handleSelectAll: Function, event: any) {
    event.stopPropagation();

    const { _id } = service;
    const isAdded = this.selectedInternalServices[_id];

    if (!isAdded) {
      this.selectedInternalServices[_id] = {
        ...service,
        extra: { isAdded: true },
      };
    } else {
      delete this.selectedInternalServices[_id];
    }

    handleSelectAll(!isAdded ? 'select' : 'deselect', event, true, true);
    this.handleInspectionSelectChange(event, service);
  }

  handleCalculateFlatRateTotal(bundle: any) {
    bundle.itemTotal = {
      part: 0,
      labor: 0,
      tire: 0,
      other: 0,
      sublet: 0,
      totalItemCount: 0,
      totalCost: 0,
      totalAmount: 0,
    };

    if (bundle.subItems.length) {
      var TotalCost = 0;
      bundle.subItems.forEach((subItem: any) => {
        if (subItem.isChecked) {
          if (subItem.type === 'labor') {
            TotalCost += this.calculationService.roundOff(subItem.cost * subItem.costEstimatedHours);
          } else {
            TotalCost += this.calculationService.roundOff(subItem.cost * subItem.count);
          }
          subItem.totalCost = this.calculationService.roundOff(subItem.cost * subItem.count);
          subItem.netSubtotal = this.calculationService.roundOff(subItem.price * subItem.count);

          if (subItem.itemId || (subItem.type === 'other' && subItem.title) || (subItem.type === 'sublet' && subItem.title)) {
            bundle.itemTotal[subItem.type] += subItem.netSubtotal;
            bundle.itemTotal.totalCost += subItem.totalCost;
            bundle.itemTotal.totalAmount += subItem.netSubtotal;
            bundle.itemTotal.totalItemCount += 1;
          }
        }
      });

      bundle.subItems.forEach((subItem: any) => {
        if (subItem.isChecked) {
          if (subItem.itemId || (subItem.type === 'other' && subItem.title) || (subItem.type === 'sublet' && subItem.title)) {
            if (subItem.netSubtotal) {
              subItem.flatRateAmount = this.calculationService.roundOff(subItem.netSubtotal * (bundle.flatRate / bundle.itemTotal.totalAmount));
            } else {
              subItem.flatRateAmount = 0;
            }
          }
        } else {
          subItem.flatRateAmount = 0;
        }
      });

      let totalFlatRateAmount = 0;
      bundle.subItems.forEach(({ flatRateAmount }) => {
        totalFlatRateAmount += flatRateAmount;
      });
      if (this.dataService.isOverrideCostWithTechRate) {
        // if(bundle.cost && bundle.itemTotal.totalCost){
        bundle.cost = TotalCost;
        // bundle.cost = Math.abs(bundle.cost - bundle.itemTotal.totalCost);
        // }
      }
      return bundle;
    }
  }

  handleSelectChange(event: any, itemType = '', options: any = {}) {
    if (itemType === 'bundle') {
      const { item } = options;

      const updatedItem = this.handleCalculateFlatRateTotal(item);
      event.list[item.sitemId] = updatedItem;
    }

    const { list, id } = event;
    const service = find(this.internalServices, { _id: id });

    if(event.data?.type === 'tireStorage' && event.data?.associatedInspection){
      this.handleInspectionSelectChange({}, service)
    }

    if (service) {
      if (list.length) {
        this.selectedInternalServices[id] = {
          ...service,
          extra: { isAdded: true },
          items: this.helperService.deepCopy(list),
        };
      } else {
        delete this.selectedInternalServices[id];
      }
    }
  }

  setSubletTags(item: any) {
    const subletTag = find(this.serviceTags, { name: 'Sublet' });
    const supplierUnassignedTag = find(this.serviceTags, { name: 'Supplier unassigned' });
    if (subletTag && findIndex(item.tags, { name: 'Sublet' }) < 0) {
      item.tags = [...item.tags, ...[{ ...subletTag, tagId: subletTag._id }]];
    }
    if (supplierUnassignedTag && findIndex(item.tags, { name: 'Supplier unassigned' }) < 0 && findIndex(item.tags, { name: 'Supplier assigned' }) < 0) {
      item.tags = [...item.tags, ...[{ ...supplierUnassignedTag, tagId: supplierUnassignedTag._id }]];
    }
  }

  handleCheckFlatRateSubItem(isChecked: boolean, subItem: any, item: any, service: any) {
    subItem.isChecked = isChecked;

    if (item && item.subItems && item.subItems.length) {
      const isAllSelected: boolean = item.subItems.every((currentItem: any) => currentItem.isChecked === true);

      if (isAllSelected) {
        item.checkboxIcon = 'fal fa-check';
      } else {
        item.checkboxIcon = 'fal fa-minus';
      }

      item.isChecked = item.subItems.some((currentItem: any) => currentItem.isChecked === true);

      const data = { id: service._id, list: [] };

      if (this.selectedInternalServices[data.id]) {
        data.list = this.selectedInternalServices[data.id].items;
      }

      this.handleSelectChange(data, 'bundle', { item });
    }
  }

  handleInspectionSelectChange(event: any, service: any) {
    const isAdded = this.selectedServiceInspection[service._id];
    if (!isAdded) {
      this.selectedServiceInspection[service._id] = {
        _id: service._id,
        isInspectionChecked: true,
        items: this.helperService.deepCopy(service.items),
      };
    } else {
      delete this.selectedServiceInspection[service._id];
    }
  }

  onScroll = debounce((event) => {
    const element = event.target;

    if (element.scrollHeight - element.scrollTop - element.clientHeight < 10) {
      if (this.pageIndex < this.totalPages - 1) {
        this.pageIndex++;
        this.getCannedServicesList({
          offset: this.pageIndex,
          limit: this.limit,
          skip: this.pageIndex * this.limit,
          sortField: 'title',
          sortOrder: 1,
          search: '',
          activeStatus: true,
          populateInspection: true,
        });
      }
    }
  }, 600);
}
